import { useAppFeature, useSettingsBasedAppFeature } from '../../../hooks/useAppFeature';
import { AppFeature } from '../../../types/check/flags';

interface FeatureSettings {
	hidden: boolean;
	required: boolean;
}

export const useStepFeatureSettings = () => {
	const isEditingPermitted = useAppFeature(AppFeature.EDIT_CHECK_DATA);
	const dateOfBirthSettings = useSettingsBasedAppFeature(AppFeature.DOB);
	const residenceSettings = useSettingsBasedAppFeature(AppFeature.PLACE_OF_RESIDENCE);

	const dateOfBirthFeatures = getFieldFeatures(dateOfBirthSettings);
	const residenceFeatures = getFieldFeatures(residenceSettings);

	return {
		isEditingPermitted,
		isDateOfBirthShown: !dateOfBirthFeatures.isHidden,
		isCountryShown: !residenceFeatures.isHidden,
		isDateOfBirthRequired: dateOfBirthFeatures.isRequired,
		isPlaceOfResidenceRequired: residenceFeatures.isRequired
	};
};

function getFieldFeatures(settings: FeatureSettings | null) {
	const isHidden = isFieldHidden(settings);
	const isRequired = isFieldRequired(settings, isHidden);

	return {
		isHidden,
		isRequired
	};
}

function isFieldHidden(settings: FeatureSettings | null): boolean {
	return settings !== null && settings.hidden;
}

function isFieldRequired(settings: FeatureSettings | null, isHidden: boolean): boolean {
	if (isHidden) return false;
	return settings === null || settings.required;
}
